import { FormSection } from "Components/Shared/FormSection";
import { useAddressTypeList } from "Hooks/Options/useAddressTypeList";
import { Resources, useResource } from "Translations/Resources";
import type { AddressDto } from "Infrastructure/Api/Api";
import { Stack } from "@mui/material";
import { DataRow } from "Components/Shared/DataRow/DataRow";

const RESOURCES = Resources.Pages.Content.UserDetailPageContent.AddressFields;

type Props = {
  addresses: Array<AddressDto>;
};

export const AddressDisplay = ({ addresses }: Props) => {
  const addressTypeList = useAddressTypeList();
  const { t } = useResource();

  return (
    <>
      {addresses.map((address, index) => {
        const addressTypeName =
          address.type &&
          addressTypeList.find(({ code }) => code === address.type)?.name;

        const title =
          addresses.length > 1
            ? `${index + 1}. ${t(RESOURCES.Legend)}`
            : t(RESOURCES.Legend);

        return (
          <FormSection legend={title} key={address.addressID || index}>
            <Stack gap={2}>
              <DataRow label={t(RESOURCES.Type)} value={addressTypeName} />
              <DataRow label={t(RESOURCES.Street)} value={address.street} />
              <DataRow
                label={t(RESOURCES.StreetNumber)}
                value={address.streetNumber}
              />
              <DataRow
                label={t(RESOURCES.OrientationNumber)}
                value={address.orientationNumber}
              />
              <DataRow
                label={t(RESOURCES.PostalCode)}
                value={address.postalCode}
              />
              <DataRow
                label={t(RESOURCES.Municipality)}
                value={address.municipality}
              />
            </Stack>
          </FormSection>
        );
      })}
    </>
  );
};
